import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Contacts from "./Contacts";
import Footer from "./Footer";
import worldMap from '../assets/world-map-kg.jpeg';

const Lead = () => {
    const [formData, setFormData] = useState({ email: '', name: '', text: '' });
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    const ref = useRef(null);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const csrfToken = getCookie('csrftoken');
        if (!csrfToken) { setMessage('CSRF token not found!'); return; }
        setSending(true);
        try {
            const r = await axios.post('https://kyrgyz-adventure-travel.com/api/v1/tours/lead/', formData, {
                headers: { 'accept': 'application/json', 'Content-Type': 'application/json', 'X-CSRFTOKEN': csrfToken }
            });
            if (r.status === 201) {
                setMessage('Message sent successfully!');
                setFormData({ email: '', name: '', text: '' });
            } else {
                setMessage("Error sending message. Please try again.");
            }
        } catch {
            setMessage("Error sending message. Please try again.");
        } finally {
            setSending(false);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => entries.forEach(e => {
                if (e.isIntersecting) e.target.classList.add('visible');
            }),
            { threshold: 0.1 }
        );
        const els = ref.current?.querySelectorAll('.reveal');
        els?.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={ref} id="contact" className="bg-dark py-24 md:py-36">
                <div className="container">
                    <div className="reveal flex flex-col items-center gap-4 mb-16 text-center">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-px bg-it-green opacity-90" />
                            <p className="font-unbounded text-white text-xs uppercase tracking-widest">We are here for you</p>
                            <div className="w-8 h-px bg-gold opacity-70" />
                        </div>
                        <h2 className="font-unbounded font-bold text-4xl md:text-5xl text-white">Our contacts</h2>
                        <p className="font-manrope text-white/55 text-lg max-w-xl leading-relaxed mt-2">
                            Don't hesitate to contact us. We are happy to plan your ideal trip.
                        </p>
                    </div>

                    <div className="flex flex-col md:flex-row gap-12 md:gap-20">
                        {/* Contacts */}
                        <div className="reveal w-full md:w-2/5 flex flex-col gap-6" style={{ transitionDelay: '0.1s' }}>
                            <Contacts />
                            <img
                                src={worldMap}
                                alt="Kyrgyzstan on world map"
                                className="w-full rounded-2xl opacity-80"
                            />
                        </div>

                        {/* Form */}
                        <div className="reveal w-full md:w-3/5" style={{ transitionDelay: '0.2s' }}>
                            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                                <input
                                    type="email" name="email" placeholder="Your email"
                                    className="input-dark" value={formData.email} onChange={handleChange} required
                                />
                                <input
                                    type="text" name="name" placeholder="Your name"
                                    className="input-dark" value={formData.name} onChange={handleChange} required
                                />
                                <textarea
                                    name="text" placeholder="Your message" rows={5}
                                    className="input-dark resize-none" value={formData.text} onChange={handleChange} required
                                />
                                <button
                                    type="submit"
                                    disabled={sending}
                                    className="btn-gold self-start mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {sending ? 'Sending...' : 'Send message'}
                                </button>
                                {message && (
                                    <p className={`font-manrope text-sm ${message.includes('successfully') ? 'text-gold' : 'text-red-400'}`}>
                                        {message}
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Lead;
